import { r as registerInstance, c as createEvent, h, g as getElement } from './index-5faac9d7.js';
import { af as rangeBasePath, d as EQdsButtonSize, c as EQdsButtonImportance } from './currency-7be6806c.js';
import { g as getCurrentReference } from './range-helpers-23299b55.js';
import { C as isTargetBlank, D as isLinkTypeOnline } from './index-e29b327a.js';
import { o as onDownloadLinkClickGA } from './helper-6fbc871e.js';
import './path-384d1457.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './analytics-b6a65ffa.js';
import './number-57a50dcb.js';
import './helpers-e12aa36b.js';

const rangeNodeHeaderCss = "@media screen and (max-width: 979px){.range-node-header{text-align:center}}.range-node-header__prev-level-title{font-size:0.875rem;line-height:1.25rem;font-weight:400;color:#626469}:host(:not([dir=\"rtl\"])) .range-node-header__prev-level-title{margin:0 0 0 32px}:host([dir=\"rtl\"]) .range-node-header__prev-level-title{margin:0 32px 0 0}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .range-node-header__prev-level-title{margin-left:0}:host([dir=\"rtl\"]) .range-node-header__prev-level-title{margin-right:0}}";

const RangeNodeHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.previousNodeSelected = createEvent(this, "previousNodeSelected", 7);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.handleLinkClick = (event) => {
      if (!this.isPBS)
        return;
      event.preventDefault();
      this.previousNodeSelected.emit();
      this.nodeSelected.emit({
        nodeReference: getCurrentReference(Boolean(this.backUrl), rangeBasePath, this.backUrl, this.isPBS),
      });
    };
    this.backUrl = undefined;
    this.backUrlTitle = undefined;
    this.levelTitle = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "range-node-header" }, this.backUrl && (h("qds-standalone-link", { size: "small", importance: "standard", href: this.isPBS ? '#' : this.backUrl, onClick: this.handleLinkClick, iconName: "chevron-left" }, this.backUrlTitle)), this.levelTitle && h("h4", { class: "range-node-header__prev-level-title" }, this.levelTitle)));
  }
  get el() { return getElement(this); }
};
RangeNodeHeader.style = rangeNodeHeaderCss;

const softwareModalBodyCss = "@media screen and (min-width: 980px){.pes-links{padding:5px 25px 40px}}.pes-links__row{display:block;border-bottom:1px solid #e7e6e6;margin-bottom:15px;padding:15px 0;font-size:14px}@media screen and (min-width: 980px){.pes-links__row{margin:0}}.pes-links__row:last-child{border-bottom:0}";

const SoftwareModalBody = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.data = [];
    this.ctaItem = undefined;
    this.position = undefined;
  }
  getLinkByType(row) {
    const { url, label, type, target, reference, fileName, docType } = row;
    const attr = isTargetBlank(target) ? { target: '_blank' } : { download: '' };
    const iconName = isLinkTypeOnline(type)
      ? "arrow-top-right-on-square"
      : "arrow-down-tray";
    return (h("qds-standalone-link", Object.assign({ size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, class: "pes-links__link", href: url, onClick: () => onDownloadLinkClickGA(row, row, this.position) }, attr, { "data-doc-reference": reference, "data-doc-name": fileName, "data-doc-type": docType, iconName: iconName }), label));
  }
  render() {
    return (h("div", { class: "pes-links" }, this.data.map((row) => {
      return h("div", { class: "pes-links__row" }, this.getLinkByType(row));
    })));
  }
};
SoftwareModalBody.style = softwareModalBodyCss;

export { RangeNodeHeader as pes_range_node_header, SoftwareModalBody as pes_software_modal_body };
